/**
 * Deterministic PRNG (mulberry32) shared by the client and the server-side
 * validator so both compute the *same* pool shuffle from a given seed.
 *
 * The host submits a `shuffle_pool` event carrying the seed; the client and the
 * validator each apply `applyShufflePool(state, seed)`, which uses this RNG.
 * Keeping the implementation in the engine (not the client) is what keeps the
 * two sides' `drawnCoins` in agreement — otherwise `validateDrawAndPlace`
 * rejects placements with "Placements must match drawn coins".
 *
 * Returns values in [0, 1).
 */
export function createSeededRandom(seed: number): () => number {
  let state = seed | 0;
  return () => {
    state = (state + 0x6d2b79f5) | 0;
    let t = Math.imul(state ^ (state >>> 15), 1 | state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
